(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delilica-bag-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delilica-bag-grid')) {
    customElements.define('delilica-bag-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.originalLabel = this.submitButton.textContent;
        this.status = this.querySelector('[data-bag-status]');
        this.dialog = this.querySelector('dialog');
        this.addEventListener('input', () => this.updateSelection());
        this.addEventListener('click', (event) => {
          const stepButton = event.target.closest('[data-step]');
          if (stepButton) {
            const input = stepButton.parentElement.querySelector('input');
            if (Number(stepButton.dataset.step) > 0) input.stepUp(); else input.stepDown();
            this.updateSelection();
          }
          const photo = event.target.closest('[data-photo]');
          if (photo) {
            this.dialog.querySelector('img').src = photo.dataset.photo;
            this.dialog.querySelector('img').alt = photo.dataset.name;
            this.dialog.querySelector('[data-photo-caption]').textContent = photo.dataset.name;
            this.dialog.setAttribute('aria-label', photo.dataset.name);
            this.dialog.showModal();
          }
          if (event.target.closest('[data-close-photo]') || event.target === this.dialog) this.dialog.close();
        });
        this.form.addEventListener('submit', (event) => this.addBags(event));
        this.updateSelection();
      }
      updateSelection() {
        let total = 0;
        this.querySelectorAll('input[data-variant-id]').forEach((input) => {
          const quantity = Math.max(0, Number(input.value) || 0);
          total += quantity;
          input.setAttribute('value', String(quantity));
          const buttons = input.parentElement.querySelectorAll('[data-step]');
          buttons[0].disabled = input.disabled || quantity <= 0;
          buttons[1].disabled = input.disabled || (input.hasAttribute('max') && quantity >= Number(input.max));
        });
        this.querySelector('[data-selection-count]').textContent = this.dataset.selected.replace('[count]', total);
      }
      async addBags(event) {
        event.preventDefault();
        if (this.pending) return;
        const inputs = [...this.querySelectorAll('input[data-variant-id]:not(:disabled)')];
        const invalid = inputs.find((input) => !input.checkValidity() || !Number.isInteger(Number(input.value)) || (Number(input.value) > 0 && Number(input.value) < Number(input.dataset.minimum)));
        if (invalid) { this.status.textContent = this.dataset.invalid; invalid.focus(); return; }
        const items = inputs.filter(input => Number(input.value) > 0).map(input => ({ id: input.dataset.variantId, quantity: Number(input.value) }));
        if (!items.length) { this.status.textContent = this.dataset.empty; return; }
        this.pending = true;
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.dataset.adding;
        this.status.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          this.status.textContent = this.dataset.added;
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status.textContent = error.message === 'Failed to fetch' ? this.dataset.error : error.message;
          this.submitButton.disabled = false;
          this.submitButton.textContent = this.originalLabel;
          this.pending = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delilica-tat-agreement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delilica-tat-agreement')) {
    customElements.define('delilica-tat-agreement', class extends HTMLElement {
      connectedCallback() {
        this.verify = (event) => {
          if (!event.target.closest('#checkout, .cart__checkout-button[data-route-copy]')) return;
          const checkbox = this.querySelector('input');
          if (checkbox.checked) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('[data-tat-error]').textContent = this.dataset.required;
          checkbox.focus();
        };
        window.addEventListener('click', this.verify, true);
        this.addEventListener('change', () => { this.querySelector('[data-tat-error]').textContent = ''; });
      }
      disconnectedCallback() { window.removeEventListener('click', this.verify, true); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
